import React from 'react';

function Dashboard() {
    return (
        <div>DASHBOARD, tady by byly fajn nějaké přehledy... snad do budoucna</div>
    );
}

export default Dashboard;
